export default __webpack_public_path__ + "static/media/Current employment data.5d4ecadf.png";